import type { User, UserCredential } from "firebase/auth";
import type { AuthCallback } from "./auth";

class MockAuth {
  get token() {
    return "";
  }

  get currentUser(): User {
    return {
      email: "mock@mock.przezmorze.pl",
    } as User;
  }

  getToken(): Promise<string | undefined> {
    return Promise.resolve(undefined);
  }

  onAuthStateChanged(callback: AuthCallback) {
    callback({
      info: {
        displayName: "mockUser",
        email: "user@mock.przezmorze.pl",
        phoneNumber: null,
        photoURL: null,
        providerId: "mock",
        uid: "uid",
      },
      context: { role: "ADMIN" },
    });
  }

  signInWithGoogle() {
    return Promise.resolve(undefined);
  }

  signInWithTravel360() {
    return Promise.resolve(undefined);
  }

  signInWithEmail() {
    return Promise.resolve(undefined);
  }

  isSignInWithEmailLink() {
    return false;
  }

  signInWithEmailLink(): Promise<UserCredential> {
    return Promise.resolve({} as UserCredential);
  }

  signInWithEmailAndPassword() {
    return Promise.resolve(undefined);
  }

  signUpWithEmailAndPassword() {
    return Promise.resolve();
  }

  sendPasswordResetEmail() {
    return Promise.resolve();
  }

  getRedirectResult() {
    return Promise.resolve(null);
  }

  signOut() {
    return Promise.resolve();
  }
}

export const mockAuth = new MockAuth();
